import React, { useCallback } from 'react';
import { ChatIcon, DropdownItem } from 'ui-components';

interface AddNoteDropdownItemProps {
  note?: string;
  onNoteOpen?: () => void;
  isShared?: boolean;
}

//Copied from components/TalentDropdownMenu
export function AddNoteDropdownItem({
  note,
  onNoteOpen,
  isShared,
}: AddNoteDropdownItemProps) {
  const handleOpenNote = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      if (onNoteOpen) {
        onNoteOpen();
      }
    },
    [onNoteOpen],
  );

  return !!onNoteOpen && !isShared ? (
    <DropdownItem onClick={handleOpenNote}>
      <ChatIcon boxSize={4} />
      {note?.length ? 'Edit note' : 'Add note'}
    </DropdownItem>
  ) : null;
}
